import {
    myBetList,
    mytRecordInfo
} from '../../../api/wz/updown'

import {assign, getServerTime, dataFormat } from '../../../utils/base'
import { update } from '../../../utils/vuex'

const state = {
    betList     : null,
    recordInfo  : null,
}
export default {
    namespaced: true,
    state,    
    getters: {
        betList(state) {
            return state.betList || []
        },
        recordInfo(state) {
            return state.recordInfo || {}
        },
    },

    actions: {
        async loadMyBetList ({commit}, query){
            const R = await myBetList(query)
            let betList = R.list
            
            commit('update', {
                betList
            })    
            return R 
        },
        async loadMytRecordInfo ({commit}, query){
            const R = await mytRecordInfo(query)
            let recordInfo = R.info || {}
            recordInfo.userInfo = R.userInfosMap[R.info.uid || 0] || {}
            
            commit('update', {
                recordInfo
            })
            return R 
        },
    },


    mutations: {
        update,
    }
}